module.exports = __webpack_public_path__ + "media/app/components/Footer/Tiktok.5949a3f9.svg";